import "../../utils/messages";
import { SCRIPTS_MESSAGES, SCRIPT_DEPLOY_MESSAGES } from "../../utils/messages";
import { ClientMessage } from "../../utils/objects";

export function assignScriptRequests(api) {
    let scriptUrlBase = "/enterprise/scripts/inventory";
    let scriptDeployHistoryUrl = "/enterprise/scripts/deploys";
    /*****************************************SCRIPTS INVENTORY**************************************************************/
    api.getScripts = async function () {
        var response = await api.get(scriptUrlBase, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, SCRIPTS_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });

        return response;
    }

    api.getScriptDeployHistory = async function () {
        var response = await api.get(scriptDeployHistoryUrl, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, SCRIPT_DEPLOY_MESSAGES.HISTORY_NOT_RETRIEVED);
                return [];
            });

        return response;
    }



    api.getScriptDeployResults = async function (deployID) {
        return await api.get(scriptDeployHistoryUrl + "/" + deployID+ "/results", this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, SCRIPT_DEPLOY_MESSAGES.RESULTS_NOT_RETRIEVED);
                return null;
            });
    }

    api.createScriptDeploy = async function (deploy) {
        var deployName = (deploy.deploy && deploy.deploy.name) || deploy.name || deploy.id_deploy || "";
        var clientMessage = ClientMessage.success(SCRIPT_DEPLOY_MESSAGES.CREATED, { 0: deployName }, "scriptdeploymethods");
        var response = await api.post(process.env.VUE_APP_BASE_URL_ENT + "/enterprise/scripts/deploys", deploy, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                clientMessage = this.checkError(e, SCRIPT_DEPLOY_MESSAGES.NOT_CREATED, { 0: deployName });
                return null;
            });

        this.emitFunction("sendClientMessage", clientMessage, "scriptdeploymethods");

        return response;
    }

    api.deleteScriptDeploy = async function (deployID) {
        var clientMessage = ClientMessage.success(SCRIPT_DEPLOY_MESSAGES.DELETED, { 0: deployID }, "scriptdeploymethods");
        var response = await api.delete(scriptDeployHistoryUrl + "/" + deployID, this.buildConfig())
            .then(() => true)
            .catch(e => {
                clientMessage = this.checkError(e, SCRIPT_DEPLOY_MESSAGES.NOT_DELETED, { 0: deployID });
                return false;
            });

        this.emitFunction("sendClientMessage", clientMessage, "scriptdeploymethods");
        return response;
    }

    api.getScript = async function (scriptID) {
        var response = await api.get(scriptUrlBase + "/" + scriptID, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, SCRIPTS_MESSAGES.LIST_NOT_RETRIEVED);
                return null;
            });

        return response;
    }

    api.createScript = async function (script) {
        var clientMessage = ClientMessage.success(SCRIPTS_MESSAGES.CREATED, { 0: script.name }, "scriptmethods");
        var response = await api.post(scriptUrlBase, script, this.buildConfig())
            .then(res => 200 <= res.status && res.status <=300)
            .catch(e => {
                clientMessage = this.checkError(e, SCRIPTS_MESSAGES.NOT_CREATED, { 0: script.name });
                return false;
            });
        this.emitFunction("sendClientMessage", clientMessage, "scriptmethods");

        return response;
    }

    api.editScript = async function (script) {
        var clientMessage = ClientMessage.success(SCRIPTS_MESSAGES.MODIFIED, { 0: script.name }, "scriptmethods");
        var response = await api.put(scriptUrlBase, script, this.buildConfig())
            .then(res => 200 <= res.status && res.status <=300)
            .catch(e => {
                clientMessage = this.checkError(e, SCRIPTS_MESSAGES.NOT_MODIFIED, { 0: script.name });
                return false;
            });
        this.emitFunction("sendClientMessage", clientMessage, "scriptmethods");


        return response;
    }

    api.deleteScript = async function (scriptID, scriptName) {
        var clientMessage = ClientMessage.success(SCRIPTS_MESSAGES.DELETED, { 0: scriptName }, "scriptmethods");
        var response = await api.delete(scriptUrlBase + "/" + scriptID, this.buildConfig())
            .then(() => true)
            .catch(e => {
                if (e.status == 404)
                    return true;
                console.writeError(e);
                clientMessage = this.checkError(e, SCRIPTS_MESSAGES.NOT_DELETED, { 0: scriptName });
                return false;
            });

        this.emitFunction("sendClientMessage", clientMessage, "scriptmethods");

        return response;
    }
    //}
}
